// TODO Try using the webpack ignore plugin to remove premium imports during compilation
// https://webpack.js.org/plugins/ignore-plugin/
// https://stackoverflow.com/questions/65004054/webpack-ignoreplugin-on-multiple-modules
// https://stackoverflow.com/questions/61822069/conditional-import-import-if-exists
// https://stackoverflow.com/questions/36367532/how-can-i-conditionally-import-an-es6-module


// console.log(ENV)
// if (ENV.tier === 'pro') {
//     console.log('tier')
// }

/**
 *  Load all essential scripts first
 */

require("./wpm")
require("./wpm__premium_only")
require("./google__premium_only")

/**
 *  Load all free scripts
 */

require("./google")
require("./google-ga-ua")
require("./google-ga-4")
require("./google-ads")
require("./facebook")
require("./hotjar")
require("./google-optimize")

/**
 *  Load all premium scripts
 */

require("./google-ga-ua-eec__premium_only")
require("./google-ga-4-eec__premium_only")
require("./tiktok__premium_only")
require("./snapchat__premium_only")
require("./pinterest__premium_only")
require("./facebook__premium_only")
require("./microsoft-ads__premium_only.js")
require("./twitter__premium_only.js")
require("./google-ads__premium_only.js")


/**
 * Execute the wpm loader. It makes sure that the script flow gets exectuded correctly, no matter how JS "optimizers" shuffle the code.
 */

require("./wpm-loader")


// console.log('WooCommerce Pixel Manager premium version')


